import * as React from "react";
import PropTypes from 'prop-types';
import { Drawer, Tab, Box, Tabs } from "@mui/material";
import PasswordChangeForm from "./PasswordChangeForm";
import PersonalDetailsForm from "./PersonalDetailsForm";
import { useSelector } from "store";
import useConfig from "../../../../hooks/useConfig";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`profile-tabpanel-${index}`}
      aria-labelledby={`profile-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `profile-tab-${index}`,
    'aria-controls': `profile-tabpanel-${index}`,
  };
}

const ProfileSettingsDrawer = ({ open, setOpen }) => {
  const [value, setValue] = React.useState(0);
  const { activeUser } = useSelector((state) => state.user);
  const { onChangeMenuType } = useConfig();
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={() => {
        onChangeMenuType(activeUser?.theme);
        setOpen(false);
      }}
    >
      <Box sx={{ width: "100%" }}>
          <Box
            sx={{
              width: 350,
              borderBottom: 1,
              borderColor: "divider"
            }}>
            <Tabs value={value} onChange={handleChange} aria-label="Profile Settings">
              <Tab label="Profile Settings" {...a11yProps(0)}></Tab>
              {!activeUser?.ssoSubject && (
                <Tab label="Change Password" {...a11yProps(1)}></Tab>
              )}
            </Tabs>
          </Box>
          <CustomTabPanel value={value} index={0}>
            <PersonalDetailsForm setOpen={setOpen} />
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            <PasswordChangeForm />
          </CustomTabPanel>
      </Box>
    </Drawer>
  );
};

export default ProfileSettingsDrawer;
